import { Box, Button, Card, Link, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { UpsellBackground } from './background'
import invoiceImage from './invoice.png'
import paymentsImage from './payments.png'

interface AccountsUpsellCardProps {
  mode: 'contact_us' | 'add_account'
  onContactUsClick?: () => void
  onAddAccountClick?: () => void
}

export const AccountsUpsellCard = ({
  mode,
  onContactUsClick,
  onAddAccountClick,
}: AccountsUpsellCardProps) => {
  const showAddAccount = mode === 'add_account'
  const showContactUs = mode === 'contact_us'

  return (
    <Box position="relative">
      <Card height="s140">
        <Card.Content>
          <Box flexDirection="row" justifyContent="spaceBetween" height="full" width="full">
            <Box
              position="absolute"
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
              borderRadius={{ all: 'abs016' }}
              overflowX="hidden"
              overflowY="hidden"
              width="full"
              height="full"
              style={{
                top: '0',
                left: '0',
                zIndex: '0',
              }}
            >
              <UpsellBackground />
            </Box>
            <Box
              width="full"
              flexDirection="column"
              justifyContent="spaceBetween"
              flexGrow
              style={{ zIndex: '3' }}
            >
              <Box maxWidth="s360" maxHeight="s48" overflowY="auto">
                <Text size="300">{i18n.t('banking.accounts.upsell.card.title')}</Text>
              </Box>
              <Box flexDirection="row" gap="s16" alignItems="center">
                {showAddAccount && (
                  <Button onClick={onAddAccountClick}>
                    {i18n.t('banking.accounts.upsell.card.add_account')}
                  </Button>
                )}
                {showContactUs && (
                  <Box onClick={onContactUsClick}>
                    <Link>{i18n.t('banking.accounts.upsell.card.more_info')}</Link>
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              width="full"
              height="full-view-height"
              position="relative"
              justifyContent="flexEnd"
              flexDirection="row"
              flexGrow
            >
              <Box
                borderRadius={{ all: 'abs008' }}
                border={{ all: { width: 's1', color: 'grey200', style: 'solid' } }}
                width="s200"
                height="s240"
                overflowX="hidden"
                overflowY="hidden"
                style={{
                  zIndex: '1',
                  boxShadow:
                    '0px 10.99px 8.8px 0px rgba(0, 0, 0, 0.0275), 0px 26.99px 17.54px 0px rgba(0, 0, 0, 0.035), 0px -20px 34.38px 0px rgba(0, 0, 0, 0.035)',
                }}
              >
                <img src={invoiceImage} height="auto" width="100%" />
              </Box>
              <Box
                position="absolute"
                borderRadius={{ all: 'abs008' }}
                border={{ all: { width: 's1', color: 'grey200', style: 'solid' } }}
                overflowX="hidden"
                overflowY="hidden"
                width="s200"
                style={{
                  right: '120px',
                  top: '36px',
                  zIndex: '2',
                  boxShadow:
                    '0px 10.99px 8.8px 0px rgba(0, 0, 0, 0.0275), 0px 26.99px 17.54px 0px rgba(0, 0, 0, 0.035), 0px 51.97px 34.38px 0px rgba(0, 0, 0, 0.0425), 0px 87.45px 63.22px 0px rgba(0, 0, 0, 0.0531), 0px -5px 17.54px 0px rgba(0, 0, 0, 0.035)',
                }}
              >
                <img src={paymentsImage} height="auto" width="100%" />
              </Box>
            </Box>
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
